import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import InsightTable from './InsightTable';
const Insight = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Insight' parent='Insight'  />
      <Container fluid={true}>
        <Row>
          <InsightTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Insight;
